// determine the route type to change the styling on the table and map pins
export const getMetroType = (routeId: number) => {
	// copied the object data from the clients original source file
	const ranges = [
		{ id: 0, name: "Main Line Routes", desc: "", from: 1, to: 99 },
		{
			id: 1,
			name: "MetroAirport, Flyer & Limited Routes",
			desc: "",
			from: 100,
			to: 199,
		},
		{ id: 2, name: "Feeder Routes", desc: "", from: 200, to: 299 },
		{ id: 3, name: "Crosstown Routes", desc: "", from: 300, to: 399 },
		{ id: 4, name: "Special Service", desc: "", from: 400, to: 499 },
		{ id: 5, name: "MetroRail", desc: "", from: 500, to: 599 },
		{ id: 6, name: "UT Shuttle Routes", desc: "", from: 600, to: 699 },
		{ id: 8, name: "High Frequency Network", desc: "", from: 800, to: 899 },
		{ id: 9, name: "Express Routes", desc: "", from: 900, to: 999 },
	];
	let id;
	ranges.forEach((item) => {
		if (routeId >= item.from && routeId <= item.to) {
			id = item.id;
		}
	});
	return id;
};
